import { useState } from "react";
import { useTradeInAemSelector } from "../../redux/store";
import type { TradeInLinkPropsType } from "../../utils/navUtils";

type UseVehicleDetailsContainerType = {
    confirmClick: (event: React.SyntheticEvent) => void;
    sortedFormItemKeys: string[]; // Used to easily loop and render form items
    showRequiredErrors: boolean;
};

const useVehicleDetailsContainer = (nextStep: TradeInLinkPropsType): UseVehicleDetailsContainerType => {
    const formItems = useTradeInAemSelector((state) => state.tradeInAemVehicleDetails.formItems);
    const [showRequiredErrors, setShowRequiredErrors] = useState<boolean>(false);

    const sortedFormItemKeys = Object.keys(formItems).sort((a, b) => formItems[a].index - formItems[b].index);

    const confirmClick = (event: React.SyntheticEvent): void => {
        event.preventDefault();

        // Check if all required form items are filled in.
        // To try to keep the setup simple there is no external validation logic (yet), similar to contactForm.
        // Everything is happening inside the React components.
        const emptyRequiredFields = !!Object.values(formItems).find(
            (formItem) => formItem.required && !formItem.value.length, // value can be a string or an array so the length check works for both.
        );

        if (emptyRequiredFields) setShowRequiredErrors(true);
        else if (nextStep.onClick) nextStep.onClick(event);
    };

    return { showRequiredErrors, sortedFormItemKeys, confirmClick };
};

export default useVehicleDetailsContainer;
